import React, { useState,useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { getValidAccessToken } from '../services/garphService';

const DisplayMessage = () => {
  const [showModal, setShowModal] = useState(true);
  const { instance, accounts } = useMsal();
 useEffect(() => {
    const getValidAccessToken = async () => {
      if (accounts.length === 0) return;

      try {
        const response = await instance.acquireTokenSilent({
          account: accounts[0],
          scopes: ["User.Read"], // 👈 Replace with your required scopes
        });

        console.log("Access Token:", response.accessToken); // ✅ LOGGED HERE
      } catch (error) {
        console.error("Failed to get token:", error);
      }
    };

    getValidAccessToken();
  }, [instance, accounts]);
  const onRequestClose = () => {
    const logoutRequest = {
      account: accounts[0],
      postLogoutRedirectUri: "/",
    };
    instance.logoutRedirect(logoutRequest);
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    minHeight: 200,
    backgroundColor: 'white',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    border: '1px solid #ccc',
    borderRadius: 8,
    padding: '24px',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };

  const backdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 999,
  };

  return (
    <>
      {showModal && (
        <>
          <div style={backdropStyle} onClick={onRequestClose} />
          <div
            style={modalStyle}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              <h2 id="modal-title" style={{ marginBottom: '12px' }}>Access Denied</h2>
              <p style={{ marginBottom: '20px' }}>
                The user does not have access to the Estate Vault in Microsoft Teams.
                {/* User does not have access. Please request access from the System Administrator. */}
              </p>
            </div>
            <div
              style={{
                marginTop: 'auto',
                textAlign: 'right',
                display: 'flex',
                justifyContent: 'flex-end',
                paddingTop: '20px',
              }}
            >
              <button
                onClick={onRequestClose}
                style={{
                  padding: '8px 16px',
                  borderRadius: '4px',
                  backgroundColor: '#007bff',
                  color: '#fff',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                OK
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DisplayMessage;
